import { Alert, Stack, Typography } from "@mui/material";
import DeleteButton from "components/Buttons/DeleteButton";
import useDeleteScript from "hooks/api/useDeleteScript";
import useGetVideos from "hooks/api/useGetVideos";
import useNavigateToScripts from "hooks/navigation/useNavigateToScripts";
import { useParams } from "react-router-dom";
import useGlobalModal from "../../ModalManagement/hooks/useGlobalModal";

export default function BtnDelete() {
  const { activeId: scriptId } = useParams() as { activeId: string };
  const { setModalContent } = useGlobalModal();
  const navigateToScripts = useNavigateToScripts();
  const { combinedPageResults: videos } = useGetVideos({
    filters: [
      {
        and: [
          ["script.id", "==", scriptId],
          ["duration", ">", 0],
        ],
      },
    ],
  });

  const { createNotificationFromResponse, deleteScript, isWriting } =
    useDeleteScript();

  async function onDelete() {
    createNotificationFromResponse(await deleteScript(scriptId));
    setModalContent(undefined);
    navigateToScripts();
  }

  function onConfirmDelete() {
    const hasVideos = videos.length > 0;

    setModalContent(
      <Stack
        sx={{ overflow: "hidden", alignItems: "center", width: "100%" }}
        spacing={2}
      >
        <Typography variant="h5" marginBottom="1rem" sx={{ height: "2rem" }}>
          {hasVideos
            ? "The script you have selected has videos uploaded to the site"
            : "Are you sure you want to delete this script?"}
        </Typography>
        {hasVideos && (
          <Alert severity="info">
            <Stack spacing={1}>
              <Typography>
                Deleting this script will not delete any videos - if you want to
                remove them you will have to manually select and delete them on
                the Video Listing Page
              </Typography>
              <Typography>
                Deleting this script will remove it from the Participant Page
                for anyone invited to it - which will also remove the script
                from their app
              </Typography>
            </Stack>
          </Alert>
        )}
        <DeleteButton
          sx={{ width: "10rem" }}
          disabled={isWriting}
          onClick={onDelete}
        />
      </Stack>,
    );
  }

  return <DeleteButton onClick={onConfirmDelete} />;
}
